import { API_GET_GESLAB_EXPORT } from 'actions/geslab';
import { API_GET_GESLAB_IMPORT } from 'actions/geslab';

export function getGeslabExport(folderId) {
	return {
		type: API_GET_GESLAB_EXPORT,
		payload: {
			request: {
				url: `geslab/export/${folderId}`
			}
		}
	};
}

export function getGeslabImport() {
	return {
		type: API_GET_GESLAB_IMPORT,
		payload: {
			request: {
				url: `geslab/import/companies`
			}
		}
	};
}
